import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import {Project, ProjectOption} from '../../classes';

@Component({
  selector: 'geo-tools',
  templateUrl: 'tools.component.html',
  styleUrls: ['./tools.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolsComponent implements OnInit {
  @Input() project: Project;

  tools: ToolOption[] = [];

  ngOnInit() {
    if (!this.project.parameters.tools) {
      this.project.parameters.tools = {};
    }
    const tools = this.project.parameters.tools;
    this.ensureTool(tools, 'router', false);
    this.ensureTool(tools, 'original', true);
    this.ensureTool(tools, 'catalog', true);
    this.ensureTool(tools, 'zoomin', true);
    this.ensureTool(tools, 'bookmarks', true);
    this.ensureTool(tools, 'permlink', true);
    this.ensureTool(tools, 'measure', true);
    this.ensureTool(tools, 'cartometry', false);
    this.ensureTool(tools, 'filter', true);
    this.ensureTool(tools, 'selection', true);
    this.ensureTool(tools, 'print', true);
    this.ensureTool(tools, 'charts', true);
    this.ensureTool(tools, 'table', true);

    ToolOption.serverTools = this.project.parameters.tools;
    this.tools = [
      new ToolOption('original', 'Первоначальный вид'),
      new ToolOption('catalog', 'Каталог слоев'),
      new ToolOption('zoomin', 'Увеличить область'),
      new ToolOption('bookmarks', 'Закладки'),
      new ToolOption('permlink', 'Ссылка на карту'),
      new ToolOption('measure', 'Измерения'),
      new ToolOption('router', 'Маршрутизатор'),
      new ToolOption('cartometry', 'Картометрический анализ'),
      new ToolOption('filter', 'Фильтр по атрибутам'),
      new ToolOption('selection', 'Пространственная выборка'),
      new ToolOption('print', 'Конструктор печати'),
      new ToolOption('charts', 'Аналитическая панель'),
      new ToolOption('table', 'Таблица')
    ];
  }

  get toogleButtonText(): string {
    return this.tools.some(item => !item.enable) ? 'Подключить все' : 'Отключить все';
  }

  onToggleAll(evt: MouseEvent) {
    (evt.target as HTMLButtonElement).blur();
    const state = this.tools.some(item => !item.enable);
    this.tools.forEach(item => item.enable = state);
  }

  private ensureTool(obj: any, name: string, enable: boolean) {
    if (!obj[name]) {
      obj[name] = {access: true, enable: enable};
    }
  }
}

class ToolOption {
  static serverTools: any;

  type: string;
  name: string;

  constructor(type: string, name: string) {
    this.name = name;
    this.type = type;
  }

  get access(): boolean {
    return ToolOption.serverTools[this.type] ? ToolOption.serverTools[this.type].access : false;
  }
  set access(v: boolean) {
    ToolOption.serverTools[this.type].access = v;
  }

  get enable(): boolean {
    return ToolOption.serverTools[this.type] ? ToolOption.serverTools[this.type].enable : false;
  }
  set enable(v: boolean) {
    ToolOption.serverTools[this.type].enable = v;
  }
}
